/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Record_InfoInputs */

const en_case_detail_record_info = /** @type {(inputs: Case_Detail_Record_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case info`)
};

const pt_br2_case_detail_record_info = /** @type {(inputs: Case_Detail_Record_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações`)
};

/**
* | output |
* | --- |
* | "Case info" |
*
* @param {Case_Detail_Record_InfoInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_record_info = /** @type {((inputs?: Case_Detail_Record_InfoInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Record_InfoInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_record_info(inputs)
	return pt_br2_case_detail_record_info(inputs)
});